<template>
<div class="col-12">
  <app-nav-bar></app-nav-bar>
  <div class="main-content">
    <h3 class="p-2">
      <small class="text-muted">Dashboard</small>
    </h3>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
      <div class="form-group col-2">
        <label>Module</label>
        <select type = "dropdown" class="form-control" id="module" v-model="cht.module">
          <option v-for="(list, index) in this.moduleLists" :key="index" :value="list.value">{{ list.title }}</option>
        </select>
      </div>
      <div class="form-group col-2">
        <label for="module">First Year</label>
        <select type = "dropdown" class="form-control" id="action" v-model="cht.firstYear">
          <option v-for="year in years" v-bind:key="year" :value="year">{{ year }}</option>
        </select>
        <!-- <input type="text" style="text-align: center;" class="form-control" id="complaint-no" v-model="cht.firstYear" disabled> -->
      </div>
      <!-- <div class="form-group col-2">
        <label>Second Year</label>
        <select type = "dropdown" class="form-control" id="action" v-model="cht.secondYear">
          <option v-for="year in years" v-bind:key="year" :value="year">{{ year }}</option>
        </select>
      </div> -->
      <div class="form-group col-1">
        <button type="button" style="margin-top: 32px;" @click="filter" class="btn btn-outline-success">Filter</button>
      </div>
    </div>
    <div class="p-2 dropdown-divider"></div>
    <div class="row">
      <div class="form-group col-12">
        <div id="table-caption">Summary of Customer Complaint Status</div>
        <app-datatable :type="'view'" :elements="dtElementsStatus" :collections="cht.ccfStatusData" v-on:selectedRow="selectRow"></app-datatable>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-4">
        <app-chart v-if="chartLoaded" :isMixed="false" :type="pieChart" :data="status.data" :labels="status.label" :title="status.title"></app-chart>
      </div>
      <div class="form-group col-1">
      </div>
      <div class="form-group col-6">
        <app-chart v-if="chartLoaded" :isMixed="true" :type="barChart" :dataset="category.data" :labels="category.label" :title="category.title"></app-chart>
      </div>
    </div>
    <div class="row">
      <div class="form-group col-2">
      </div>
      <div class="form-group col-8">
        <app-chart v-if="chartLoaded" :isMixed="true" :type="barChart" :dataset="month.data" :labels="month.label" :title="month.title"></app-chart>
      </div>
      <div class="form-group col-2">
      </div>
    </div>
    <!-- <div v-if="cht.module !== 'NCR'" class="row">
      <div class="form-group col-1">
      </div>
      <div class="form-group col-5">
        <app-chart v-if="chartLoaded" :isMixed="true" :type="barChart" :dataset="plantDove.data" :labels="plantDove.label" :title="plantDove.title"></app-chart>
      </div>
      <div class="form-group col-5">
        <app-chart v-if="chartLoaded" :isMixed="true" :type="barChart" :dataset="plantFatty.data" :labels="plantFatty.label" :title="plantFatty.title"></app-chart>
      </div>
    </div> -->
    <div class="row">
      <div class="form-group col-2">
      </div>
      <div class="form-group col-8">
        <app-chart v-if="chartLoaded" :isMixed="true" :type="barChart" :dataset="department.data" :labels="department.label" :title="department.title"></app-chart>
      </div>
      <div class="form-group col-2">
      </div>
    </div>
    <div v-if="cht.module !== 'NCR'" class="row">
      <div class="form-group col-2">
      </div>
      <div class="form-group col-8">
        <app-chart v-if="chartLoaded" :isMixed="true" :type="barChart" :dataset="product.data" :labels="product.label" :title="product.title"></app-chart>
      </div>
      <div class="form-group col-2">
      </div>
    </div>
    <div class="row">
      <div v-if="cht.module !== 'NCR'" class="form-group col-4">
        <div id="table-caption">{{this.cht.titleTop10CustomerPerModule}}</div>
        <app-datatable :type="'view'" :elements="dtElementsCustomer" :collections="cht.ccfLatestCustomer" v-on:selectedRow="selectRow"></app-datatable>
      </div>
      <div v-if="cht.module !== 'NCR'" class="form-group col-8">
        <div id="table-caption">{{this.cht.titleTop10PerModule}}</div>
        <app-datatable :type="'view'" :elements="dtElementsCCF" :collections="cht.ccfLatestData" v-on:selectedRow="selectRow"></app-datatable>
      </div>
      <div v-if="cht.module === 'NCR'" class="form-group col-12">
        <div id="table-caption">{{this.cht.titleTop10PerModule}}</div>
        <app-datatable :type="'view'" :elements="dtElementsNcr" :collections="cht.ccfLatestData" v-on:selectedRow="selectRow"></app-datatable>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import AppDatatable from '../components/AppDatatable.vue'
import AppChart from '../components/AppChart.vue'
import { chart, ccfLatestData, ccfLatestCustomer } from '../models/chart'
// import AppDataPagination from '../components/AppDataPagination.vue'
// import AppGoogleMaps from '../components/AppGoogleMaps.vue'
import AppNavBar from '../components/AppNavbar.vue'
// import AppGooglePlaceAutocomplete from '../components/AppGooglePlaceAutocomplete.vue'
import api from '../services/api'
import moment from 'moment'

export default {
  components: {
    AppDatatable, AppNavBar, AppChart
  },
  data() {
    return {
      cht: {...chart, ccfLatestData:[], ccfLatestCustomer: [], ccfStatusData:[]},

      moduleLists: [
        {
          title: 'Customer Complaint',
          value: 'Customer Complaint'
        },
        {
          title: 'NCR',
          value: 'NCR'
        },
        {
          title: 'Recall',
          value: 'Recall'
        },
      ],

      dtElementsCCF: [
        {
          title: 'Complaint No',
          column: 'complaintNo',
          type: 'text',
          width: 2,
        },
        {
          title: 'Issued Date',
          column: 'reportedDate',
          type: 'date',
          width: 2,
        },
        {
          title: 'Customer Name',
          column: 'customerName',
          type: 'text',
          width: 3,
        },
        {
          title: 'Product Name',
          column: 'productName',
          type: 'text',
          width: 3,
        },
        {
          title: 'Description',
          column: 'description',
          type: 'text'
        },
        {
          title: 'Status',
          column: 'transactionStatus',
          type: 'text',
          width: 2,
        },
      ],

      dtElementsNcr: [
        {
          title: 'Complaint No',
          column: 'complaintNo',
          type: 'text',
          width: 2,
        },
        {
          title: 'Issued Date',
          column: 'reportedDate',
          type: 'date',
          width: 2,
        },
        {
          title: 'Description',
          column: 'description',
          type: 'text'
        },
        {
          title: 'Status',
          column: 'transactionStatus',
          type: 'text',
          width: 2,
        },
      ],

      dtElementsCustomer: [
        {
          title: 'Customer Name',
          column: 'name',
          type: 'text'
        },
        {
          title: 'Count',
          column: 'count',
          type: 'text'
        },
      ],

      dtElementsStatus: [
        {
          title: 'Submitted',
          column: 'submitted',
          type: 'text',
        },
        {
          title: 'Under Validation',
          column: 'underValidation',
          type: 'text',
        },
        {
          title: 'Under Investigation',
          column: 'underInvestigation',
          type: 'text',
        },
        {
          title: 'CPAR Under Review',
          column: 'cparUnderReview',
          type: 'text',
        },
        {
          title: 'CPAR Sent, Waiting Feedback',
          column: 'cparSent',
          type: 'text',
        },
        {
          title: 'Over Due',
          column: 'overDue',
          type: 'text',
        },
        {
          title: 'On Due',
          column: 'onDue',
          type: 'text',
        },
        {
          title: 'Closed',
          column: 'closed',
          type: 'text',
        },
      ],

      pieChart: 'pie',
      lineChart: 'line',
      barChart: 'bar',
      mixedChart: 'mixed',
      chartLoaded: false,
      selectedId: '',

      status: {},
      category: {},
      month: {},
      plantDove: {},
      plantFatty: {},
      department: {},
      product: {},

      titleTop10PerModule: '',
      titleTop10CustomerPerModule: '',
    }
  },
  async created() {
    this.init()
  },
  computed : {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 2017}, (value, index) => 2018 + index)
    }
  },
  methods: {
    async init() {
      this.cht.firstYear = moment().format('YYYY')
      this.cht.secondYear = moment().format('YYYY')
      this.cht.module = 'Customer Complaint'

      this.filter()
    },
    async filter() {
      this.chartLoaded = false

      const query = {
        params: {
          firstYear: this.cht.firstYear,
          secondYear: this.cht.secondYear,
          plantDoveAndSoap: 'Dove and Soap',
          plantFattyAcid: 'Fatty Acid'
        }
      }

      

      // const plantDoveApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-plant-dns') : api('get-recall-by-plant-dns')
      // const plantDoveData = await plantDoveApi.getWithQuery(query)
      // this.plantDove = plantDoveData

      // const plantFattyApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-plant-fa') : api('get-recall-by-plant-fa')
      // const plantFattyData = await plantFattyApi.getWithQuery(query)
      // this.plantFatty = plantFattyData

      





      // const ccfStatusApi = api('get-status-data')
      // const ccfStatusData = await ccfStatusApi.get()
      // this.cht.ccfStatusData = ccfStatusData

      const ccfStatusApi = api('get-status-data')
      const ccfStatusData = await ccfStatusApi.getWithQuery(query)
      this.cht.ccfStatusData = ccfStatusData

      const statusApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-status') : this.cht.module === 'NCR' ? api('get-ncr-by-status') : api('get-recall-by-status')
      const statusData = await statusApi.getWithQuery(query)
      this.status = statusData

      const categoryApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-category') : this.cht.module === 'NCR' ? api('get-ncr-by-category') : api('get-recall-by-category')
      const categoryData = await categoryApi.getWithQuery(query)
      this.category = categoryData

      const monthApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-month') : this.cht.module === 'NCR' ? api('get-ncr-by-month') : api('get-recall-by-month')
      const monthData = await monthApi.getWithQuery(query)
      this.month = monthData

      const departmentApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-department') : this.cht.module === 'NCR' ? api('get-ncr-by-department') :  api('get-recall-by-department')
      const departmentData = await departmentApi.getWithQuery(query)
      this.department = departmentData

      const productApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-product') : api('get-recall-by-product')
      const productData = await productApi.getWithQuery(query)
      this.product = productData

      const ccfLatestApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-latest') : this.cht.module === 'NCR' ? api('get-ncr-by-latest') : api('get-recall-by-latest')
      const ccfLatestData = await ccfLatestApi.get()
      this.cht.ccfLatestData = ccfLatestData.data
      this.cht.titleTop10PerModule = ccfLatestData.title

      const ccfCustomerApi = this.cht.module === 'Customer Complaint' ? api('get-cc-by-latest-customer') : api('get-recall-by-latest-customer')
      const ccfCustomerData = await ccfCustomerApi.get()
      this.cht.ccfLatestCustomer = ccfCustomerData.data
      this.cht.titleTop10CustomerPerModule = ccfCustomerData.title

      this.chartLoaded = true
    },
    selectRow(id) {
      this.selectedId = id
    },
  }  
}
</script>